import script from "./fromThirdReg.vue?vue&type=script&setup=true&lang=js"
export * from "./fromThirdReg.vue?vue&type=script&setup=true&lang=js"

import "./fromThirdReg.vue?vue&type=style&index=0&id=92855b62&lang=less&scoped=true"

import exportComponent from "/data/web/antpay-h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-92855b62"]])

export default __exports__